import { ImageWrapper, pxToRem, SecondaryButton } from '@geneo2-web/shared-ui';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import { useState } from 'react';

interface DownloadMenuItem {
  name: string;
  onClick: () => void;
}
interface DownloadActionButtonProps {
  text: string;
  backgroundColor: string;
  borderColor: string;
  textColor?: string;
  menuItems?: DownloadMenuItem[];
  onClick?: () => void;
}

export const DownloadActionButton = ({
  text,
  backgroundColor,
  borderColor,
  textColor = '#000000',
  menuItems = [],
  onClick,
}: DownloadActionButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick();
      return;
    }
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        sx={{
          minWidth: pxToRem(298),
          width: 'max-content',
          height: pxToRem(49),
          backgroundColor,
          border: `1px solid ${borderColor}`,
          borderRadius: pxToRem(8),
          color: textColor,
          boxShadow: 'none',
          //removing default effects
          '&:hover': {
            backgroundColor,
            border: `1px solid ${borderColor}`,
            color: textColor,
            boxShadow: 'none',
          },
          '&:active': {
            backgroundColor,
            border: `1px solid ${borderColor}`,
            color: textColor,
            boxShadow: 'none',
          },
          '&:focus': {
            backgroundColor,
            border: `1px solid ${borderColor}`,
            color: textColor,
            boxShadow: 'none',
          },
        }}
        onClick={handleClick}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: pxToRem(8),
          }}
        >
          <ImageWrapper
            name="download-black"
            parentFolder="icons"
            type="png"
            styles={{
              width: pxToRem(23.4),
              height: pxToRem(25),
            }}
          />

          <Typography
            sx={{
              fontFamily: 'Poppins',
              fontWeight: 500,
              fontSize: pxToRem(18),
              lineHeight: '100%',
              color: textColor,
            }}
          >
            {text}
          </Typography>
        </Box>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        onClick={(e) => e.stopPropagation()}
      >
        {menuItems.map((item, index) => (
          <MenuItem
            key={index}
            onClick={(e) => {
              e.stopPropagation();
              handleMenuClose();
              item.onClick();
            }}
          >
            <Typography
              variant="smallText"
              fontWeight="regular"
              sx={{
                fontFamily: 'Poppins',
              }}
            >
              {item.name}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
